import React from 'react';
import { Link } from 'react-router-dom';
import './Profile.css';
import Header from '../common/Header';
import httpService from "../../services/HttpService";

const Profile = () => {
    const isAuthenticated = !!localStorage.getItem('auth_token');

    const handleLogout = async () => {
        try {
            await httpService.post('/logout');  // Use the httpService to call the logout API
            localStorage.removeItem('auth_token');
            window.location.reload();
        } catch (error) {
            console.error('Ошибка при выходе:', error);
        }
    };

    return (
        <>
            <Header />
            <main className="profile-main">
                <div className="profile-content">
                    <section className="profile-section">
                        <h2 className="section-title">Профиль</h2>
                        <ul className="profile-links">
                            <li>
                                <Link to="/profile-data">
                                    <i className="material-symbols-sharp">person</i>
                                    Персональные данные
                                </Link>
                            </li>
                            <li>
                                <Link to="/saved">
                                    <i className="material-symbols-sharp">bookmark_border</i>
                                    Сохраненные
                                </Link>
                            </li>
                            <li>
                                <Link to="/orders">
                                    <i className="material-symbols-sharp">shopping_cart</i>
                                    Заказы
                                </Link>
                            </li>
                            <li>
                                <Link to="/refunds">
                                    <i className="material-symbols-sharp">assignment_return</i>
                                    Возвраты
                                </Link>
                            </li>
                            <li>
                                <Link to="/cards">
                                    <i className="material-symbols-sharp">credit_card</i>
                                    Карты
                                </Link>
                            </li>
                            <li>
                                <Link to="/address-list">
                                    <i className="material-symbols-sharp">home</i>
                                    Адреса
                                </Link>
                            </li>
                            {/*<li>*/}
                                {/*<Link to="/notifications">*/}
                                {/*    <i className="material-symbols-sharp">notifications</i>*/}
                                {/*    Уведомления*/}
                                {/*</Link>*/}
                            {/*</li>*/}
                            <li>
                                <Link to="/language">
                                    <i className="material-symbols-sharp">language</i>
                                    Язык
                                    <span className="link-extra">Русский</span>
                                </Link>
                            </li>
                        </ul>
                    </section>

                    <section className="profile-section">
                        <h2 className="section-title">О Нас</h2>
                        <ul className="profile-links">
                            <li>
                                <Link to="/privacy-policy">
                                    <i className="material-symbols-sharp">verified_user</i>
                                    Политика обработки персональных данных
                                </Link>
                            </li>
                            <li>
                                <Link to="/order-contract">
                                    <i className="material-symbols-sharp">description</i>
                                    Публичная оферта
                                </Link>
                            </li>
                            <li>
                                <a href="https://t.me/zametna_com" target="_blank" rel="noopener noreferrer">
                                    <i className="material-symbols-sharp">support_agent</i>
                                    Служба поддержки
                                </a>
                            </li>
                        </ul>
                    </section>

                    <section className="profile-section">
                        <h2 className="section-title">Аккаунт</h2>
                        <ul className="profile-links">
                            {isAuthenticated ? (
                                <li onClick={handleLogout} className="logout-button">
                                    <i className="material-symbols-sharp">logout</i>
                                    Выйти
                                </li>
                            ) : (
                                <li>
                                    <Link to="/auth">
                                        <i className="material-symbols-sharp">login</i>
                                        Войти
                                    </Link>
                                </li>
                            )}
                            <li className="delete-account">
                                <Link to="/delete-account">
                                    <i className="material-symbols-sharp">delete</i>
                                    Удалить аккаунт
                                </Link>
                            </li>
                        </ul>
                    </section>
                </div>
            </main>
        </>
    );
};

export default Profile;
